import React, { FC, ReactNode, useCallback } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { Browser } from 'components/Browser/Browser';
import styles from './WebpagePreview.scss';
import { Webpage } from 'components/Webpage/Webpage';
import { SkeletonGroup, SkeletonRectangle } from '@wix/design-system';

type Props = {
  skeletonEnabled?: boolean;
  headerTitle?: string;
};

export const WebpagePreview: FC<Props> = ({ skeletonEnabled = false, headerTitle }) => {
  const { t } = useTranslation();

  const renderWrapper = useCallback(
    (content: ReactNode) => {
      if (skeletonEnabled) {
        return <SkeletonGroup>{content}</SkeletonGroup>;
      }

      return content;
    },
    [skeletonEnabled],
  );

  return (
    <div className={styles.webpagePreview}>
      <div className={styles.webpagePreviewBrowser}>
        <Browser>
          <Webpage
            menuItems={t('globals.preview.browser-webpage.menu-items').split(',')}
            selectedMenuItemIndex={1}
            headerTitle={headerTitle}
          >
            {renderWrapper(
              <div className={styles.webpagePreviewContent}>
                <div className={styles.webpagePreviewProducts}>
                  {[...Array(4)].map((_, index) => (
                    <div className={styles.webpagePreviewProductsItem} key={index}>
                      <SkeletonRectangle width="100%" height="180px" />
                      <div className={styles.webpagePreviewProductsItemTitle}>
                        <SkeletonRectangle width="100%" height="20px" />
                      </div>
                      <div className={styles.webpagePreviewProductsItemButton}>
                        <SkeletonRectangle width="100%" height="20px" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>,
            )}
          </Webpage>
        </Browser>
      </div>
    </div>
  );
};
